define('view/disclosure/disclosure.documents.tab.page.view',['require','exports','module','blockit','uikit/uikit','blockit','backbone.radio','fukit','view/disclosure/action.items.component','view/disclosure/document.list.action.buttons','view/disclosure/document.action.edit.view','view/disclosure/document.action.edit.name.view','view/disclosure/persistent.left.sidebar','view/disclosure/persistent.left.sidebar.modals','behavior/select.and.upload.files.behavior','behavior/drag.and.drop.files.behavior','fukit','behavior/navigate.on.tab.press.behavior'],function(require, exports, module) {
    // prettier-ignore
    var BlocKit                     = require('blockit'),
        UIKit                       = require('uikit/uikit'),
        BlocKit                     = require('blockit'),
        Radio                       = require('backbone.radio'),
        ROLES                       = require('fukit').Roles,
        ActionItemsComponent        = require('view/disclosure/action.items.component'),

        //table row views
        DocumentListActionButtons = require('view/disclosure/document.list.action.buttons'),
        DocumentActionEditView    = require('view/disclosure/document.action.edit.view'),
        DocumentActionEditFileNameView = require('view/disclosure/document.action.edit.name.view'),

        //persistent left sidebar and modals
        PersistentLeftSidebar       = require('view/disclosure/persistent.left.sidebar'),
        PersistentLeftSidebarModals = require('view/disclosure/persistent.left.sidebar.modals'),

        //behaviors
        SelectAndUploadFilesBehavior  = require('behavior/select.and.upload.files.behavior'),
        DragAndDropFilesBehavior      = require('behavior/drag.and.drop.files.behavior'),
        AuthorizationBehavior       = require('fukit').AuthorizationBehavior,
        NavigateOnTabPressBehavior  = require('behavior/navigate.on.tab.press.behavior');


    var DisclosureDocumentsPageLayout = BlocKit.ResolveOptionsView.extend({
        resolveOptions: {
          modals: PersistentLeftSidebarModals,

          //Parent two column layout
            //combine with sidebar modals
             root: {
                type: BlocKit.TwoColumnLeftRailLayoutView,
                pageHeader: {
                    headerText: 'COI Disclosures',
                    breadcrumbs: [
                        {
                            text: 'COI Disclosures',
                            route: 'disclosure:list',
                            behaviors: {
                                AuthorizationBehavior: {
                                    // for COI Admin
                                    visibleOnlyWhen: [
                                        {
                                            roles: [ROLES.COI_EFORM_TEMPLATE_ACCESS]
                                        },
                                    ],
                                    behaviorClass: AuthorizationBehavior
                                }
                            },
                        },

                        {
                            // Note: text should have a binding to a field disclosureOwnerFullName
                            text: 'Disclosure - Owner',
                            behaviors: {
                                updateCrumbWithPersonNameBehavior: {
                                    behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                                    optionValues: {
                                        text: {
                                            formatter: function() {
                                                var disclosureDetailModel = Radio.request(
                                                    'AppKit.resourceService',
                                                    'resource',
                                                    'disclosure'
                                                );
                                                var displayName = '';

                                                if (disclosureDetailModel) {
                                                    var fullName = disclosureDetailModel.get('disclosureOwnerFullName');

                                                    if (fullName && fullName.trim().length > 0) {
                                                        displayName = displayName + fullName;
                                                    }
                                                }

                                                return displayName;
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    ],
                    //Action buttons are created from workflow options available to the user at any given step in the workflow
                    //Since the tabbed views have the same actions component definition, we've moved those into a common module
                    actionsFromCollection: ActionItemsComponent,
                },
                contentColumn: {
                    components: [
                        {
                            type: BlocKit.TabsContainerView,
                            openTabIndex: 1,
                            behaviors: {
                                navigateOnTabPress: {
                                    routeParams: { primaryId: '@state.primaryId' },
                                    behaviorClass: NavigateOnTabPressBehavior,
                                },
                            },
                            components: [
                                {
                                    tabMenuItem: {
                                        text: 'COI Disclosure Answers',
                                        horizontalNavMode: true,
                                        routeName: 'disclosure:form',
                                        attributes: {
                                            style: 'cursor: pointer;',
                                        },
                                    },
                                },

                                {
                                    tabMenuItem: {
                                        text: 'Documents',
                                        horizontalNavMode: true,
                                    },
                                    tabContent: {
                                      type: BlocKit.AttachedComponentsContainerView,
                                      components: [
                                          {
                                              type: UIKit.Table.extend({
                                                  className: 'ui very basic table',
                                              }),

                                              collection: '@resources.documentsCollection',
                                              id: 'documentsTabTable',

                                              columns: [
                                                      {
                                                          text: 'Document Name',
                                                          childView: DocumentActionEditFileNameView,
                                                          childViewOptions: {
                                                              visible: true,
                                                          },
                                                      },

                                                      {
                                                          text: 'Uploaded',
                                                          data: 'createDate',
                                                          formatter: BlocKit.Formatter.date({
                                                              format: 'DD MMM YYYY',
                                                              emptyValue: '--',
                                                          }),
                                                      },

                                                       {
                                                          text: 'Document Type',
                                                          childView: DocumentActionEditView,
                                                          childViewOptions: {
                                                              visible: true,
                                                              collection: '@resources.documentsCollection',
                                                              documentTypeCollection: '@resources.DocumentTypeCollection',
                                                           },
                                                      },

                                                       {
                                                          width: '12em',
                                                          childView: DocumentListActionButtons,
                                                        },

                                                  ],
                                                  table: {
                                                      emptyText: 'No documents.',
                                                     selectable: false,
                                                  },
                                          },
                                          ////// upload file component:
                                          {
                                              type: UIKit.ComponentsContainerView,
                                              className: 'attachment point',
                                              id: 'attachment-point',
                                              behaviors: {
                                                  DragAndDropFilesBehavior: {
                                                      behaviorClass: DragAndDropFilesBehavior,
                                                  },
                                              },
                                              components: [
                                                  {
                                                      type: UIKit.Text,
                                                      className: UIKit.Text.prototype.className + ' descriptive',
                                                      text: 'Drop files here to upload',
                                                  },
                                                  {
                                                      type: UIKit.Text,
                                                      className: UIKit.Text.prototype.className + ' descriptive sub',
                                                      text: 'or',
                                                  },
                                                  {
                                                      type: UIKit.Button,
                                                      color: 'primary',
                                                      text: 'Upload File',
                                                      icon: 'upload',
                                                       behaviors: {
                                                           BindAndFormatOptionValuesBehavior: {
                                                               optionValues: {
                                                                  disabled: {
                                                                      formatter: function() {
                                                                          var previewMode = Radio.request('AppKit.controllerService', 'state').get('previewMode');

                                                                          if (this.view.disabled || previewMode) {
                                                                              return true;
                                                                          }
                                                                          return false;
                                                                      },
                                                                  },
                                                              },
                                                              behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                                                          },
                                                          SelectAndUploadFilesBehavior: {
                                                              useS3Uploader: false,
                                                              fineUploaderOptions: function () {
                                                                  return {
                                                                      multiple: false,
                                                                      chunking: {
                                                                          enabled: false,
                                                                      },
                                                                      retry: {
                                                                          enableAuto: false,
                                                                      },
                                                                      request: {
                                                                          endpoint: '/api/v1/attachments/files',
                                                                          inputName: 'file',
                                                                          params: {
                                                                              attachmentPoint: Radio.request('AppKit.controllerService', 'state').get('primaryId'),
                                                                          }
                                                                      },
                                                                  };
                                                              },
                                                              behaviorClass: SelectAndUploadFilesBehavior,
                                                          },
                                                          SaveUploadAnswerOnUploadComplete: {
                                                              eventName: 'upload:complete',
                                                              useEventArguments: true,
                                                              method: function(view, fileIndex, fileName, resp, xhr) {

                                                                  if(resp.success) {

                                                                      var documentsCollection = Radio.request('AppKit.resourceService', 'resource', 'documentsCollection');
                                                                      documentsCollection.fetch().promise().bind(this);

                                                                  }
                                                               },
                                                              behaviorClass: BlocKit.InvokeMethodOnEventBehavior,
                                                          },
                                                          TriggerResourceErrorOnDocumentUploadError: {
                                                              eventName: 'upload:error',
                                                              useEventArguments: true,
                                                              method: function(view, fileIndex, fileName, resp, xhr) {
                                                                var documentsCollection = Radio.request('AppKit.resourceService', 'resource', 'documentsCollection');
                                                                var error = { xhr: _.extend({}, xhr, { responseJSON: JSON.parse(xhr.response) }) };
                                                                documentsCollection.trigger('error', documentsCollection, error);
                                                               },
                                                              behaviorClass: BlocKit.InvokeMethodOnEventBehavior,
                                                          },
                                                      },
                                                  },
                                              ],
                                          },
                                          //////--------

                                      ],
                                    },
                                },

                                {
                                    tabMenuItem: {
                                        text: 'Process History',
                                        horizontalNavMode: true,
                                        routeName: 'disclosure:history',
                                        attributes: {
                                            style: 'cursor: pointer;',
                                        },
                                    },
                                },

                            ],
                        },
                    ],
                },
                //Persistent left column process information, workflow tasks, etc.
                railColumn: PersistentLeftSidebar,
            },
        },
    });

    module.exports = DisclosureDocumentsPageLayout;
});







